/**
 * Web Vitals reporting function with enhanced analytics
 *
 * Collects and reports Core Web Vitals metrics:
 * - CLS: Cumulative Layout Shift
 * - FID: First Input Delay
 * - FCP: First Contentful Paint
 * - LCP: Largest Contentful Paint
 * - TTFB: Time to First Byte
 *
 * @param {Function} onPerfEntry - Callback function to handle metrics
 */
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ onCLS, onFID, onFCP, onLCP, onTTFB }) => {
      // Measure CLS - layout stability
      onCLS((metric) => {
        const analyticsData = {
          name: "CLS",
          value: metric.value,
          delta: metric.delta,
          id: metric.id,
        };
        onPerfEntry(analyticsData);
      });

      // Measure FID - interactivity
      onFID((metric) => {
        const analyticsData = {
          name: "FID",
          value: metric.value,
          delta: metric.delta,
          id: metric.id,
        };
        onPerfEntry(analyticsData);
      });

      // Measure FCP - initial render
      onFCP((metric) => {
        const analyticsData = {
          name: "FCP",
          value: metric.value,
          delta: metric.delta,
          id: metric.id,
        };
        onPerfEntry(analyticsData);
      });

      // Measure LCP - perceived load speed
      onLCP((metric) => {
        const analyticsData = {
          name: "LCP",
          value: metric.value,
          delta: metric.delta,
          id: metric.id,
        };
        onPerfEntry(analyticsData);
      });

      // Measure TTFB - server response time
      onTTFB((metric) => {
        const analyticsData = {
          name: "TTFB",
          value: metric.value,
          delta: metric.delta,
          id: metric.id,
        };
        onPerfEntry(analyticsData);
      });
    });
  }
};

export default reportWebVitals;
